/**
 * Action 类似于 mutation，不同在于：
 * Action 提交的是 mutation，而不是直接变更状态。
 * Action 可以包含任意异步操作。
 * Action 通过 store.dispatch 方法触发：
 * store.dispatch('setValueSet')
 */
export default {
  setValueSet({ commit }, payload) {
    commit("setValueSet", payload);
  },
};
